module.exports = __webpack_public_path__ + "static/media/0012.316af426.jpg";